export const enum MemberLevel {
  ADMIN = 'Admin',
  DEVELOPER = 'Developer',
}
